export default __webpack_public_path__ + "static/media/ahmad.d499a48b.jpg";